import type { SupportedRepubName } from './types';

export type ThemeName = 'whoscored' | 'gazzetta' | 'plus' | 'oddschecker';

export type UIBehaviorConfig = {
  theme: ThemeName;
};

export const UI_BEHAVIOR_CONFIGS = {
  WS: {
    theme: 'whoscored' as const,
  },
  US: {
    theme: 'plus' as const,
  },
  OC: {
    theme: 'plus' as const,
  },
  GZ: {
    theme: 'gazzetta' as const,
  },
} satisfies Record<SupportedRepubName, UIBehaviorConfig>;
